import React, { useEffect } from "react";
import { Spinner } from "@/components/ui/spinner";

// Hook to detect dark mode
const useDarkMode = () => {
  const [isDark, setIsDark] = React.useState(
    () => document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains('dark'));
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, []);

  return isDark;
};

export const CoingeckoSymbolChart = ({ coingeckoCoinId, baseCurrency }) => {
  const isDarkMode = useDarkMode();
  useEffect(() => {
    // Check if script already exists
    const scriptId = "coingecko-price-widget-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.src =
        "https://widgets.coingecko.com/gecko-coin-price-chart-widget.js";
      script.id = scriptId;
      script.async = false;
      script.type = "text/javascript";
      document.body.appendChild(script);
    }
    const hideWatermark = () => {
      const widget = document.querySelector(
        "gecko-coin-price-chart-widget"
      ) as HTMLElement & { shadowRoot?: ShadowRoot };
      if (widget?.shadowRoot) {
        const wm =
          widget.shadowRoot.querySelector<HTMLDivElement>(".gecko-watermark");
        if (wm) {
          wm.style.display = "none";
          return true;
        }
      }
      return false;
    };

    if (!hideWatermark()) {
      const observer = new MutationObserver(() => {
        if (hideWatermark()) {
          observer.disconnect();
        }
      });
      observer.observe(document.body, { subtree: true, childList: true });
    }
  }, [coingeckoCoinId, baseCurrency]);

  return (
    <div className="w-full rounded-xl overflow-hidden bg-card border border-border">
      {baseCurrency && coingeckoCoinId ? (
        <gecko-coin-price-chart-widget
          key={coingeckoCoinId + (baseCurrency || "usd").toLowerCase() + isDarkMode}
          locale="en"
          outlined="false"
          dark-mode={isDarkMode ? "true" : "false"}
          coin-id={coingeckoCoinId}
          initial-currency={(baseCurrency || "usd").toLowerCase()}
        />
      ) : (
        <div className="flex items-center justify-center h-[400px]">
          <Spinner size={32} />
        </div>
      )}
    </div>
  );
};
